// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logic-flow-view[data-v-272da39c]{height:100vh;position:relative}", ""]);
// Exports
module.exports = exports;
